<template>
  <div id="airsset_widget">
      <Dashboard />
      <Footer></Footer>
  </div>
</template>

<script>

import Footer from '@/components/Footer'
import Dashboard from '@/pages/Dashboard'

export default {
  name: 'app',
  components: {
    Dashboard,
    Footer
  }
}
</script>

<style>
  body #airsset_widget {
    width: 100%;
    max-width: 300px;
    font-family: "Roboto", "Helvetica Neue", Arial ,sans-serif !important;
    font-weight: 400;
    color: white;
    font-size: 0.8rem;
    background: transparent;
    letter-spacing: normal;
  }
  #airsset_widget .md-card {
    box-shadow: none;
    background: none;
  }

  @media only screen and (min-width: 750px) {
    #airsset_widget {
      width: 100%;
      max-width: 300px;
    }
  }
</style>
